import { Reducer } from 'redux'
import { WorkloadActionTypes } from './action'

export interface Workload {
  workloadId: string
  workloadArn: string
  workloadName: string
  status: string
  reviewOwner: string
  createdAt: string
  lenses: string[]
  highRisk: number
  mediumRisk: number
  unanswered: number
  noneRisk: number
  notApplicable: number
  improvementStatus: string
  progressBarPercentage?: number
  flagged?: string
  totalFlaggedQuestionsCount: number
}

export interface WorkloadState {
  workload: Workload[]
  selectedWorkload?: Workload
  pageNumber: number
  rowsPerSize: number
  totalNumberOfPages: number
  totalWorkloadsCount: number
  hasMore?: boolean
  error?: string
  initialPage?: boolean
  links?: {}
}

export const initialState: WorkloadState = {
  workload: [],
  selectedWorkload: {} as Workload,
  pageNumber: 1,
  rowsPerSize: 10,
  totalNumberOfPages: 0,
  totalWorkloadsCount: 0,
  hasMore: true,
  initialPage: true,
  links: {},
}

type actionType =
  | {
      type: WorkloadActionTypes.SET_WORKLOAD
      payload: WorkloadState
    }
  | {
      type: WorkloadActionTypes.SET_SELECTED_WORKLOAD
      payload: Workload
    }
  | {
      type: WorkloadActionTypes.CLEAR_WORKLOAD
    }
  | {
      type: WorkloadActionTypes.CLEAR_SELECTED_WORKLOAD
    }
  | {
      type: WorkloadActionTypes.SET_ERROR
      payload: string
    }
  | {
      type: WorkloadActionTypes.SET_INTIAL_PAGE
    }
  | {
      type: WorkloadActionTypes.CLEAR_INITIAL_PAGE
    }

export const reducer: Reducer<WorkloadState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case WorkloadActionTypes.SET_ERROR: {
      return {
        ...state,
        error: action.payload,
      }
    }
    case WorkloadActionTypes.SET_WORKLOAD: {
      return {
        ...state,
        workload:
          action.payload.pageNumber === 1
            ? action.payload.workload
            : [...state.workload, ...action.payload.workload],
        pageNumber: action?.payload?.pageNumber + 1,
        hasMore: action.payload.pageNumber < action.payload.totalNumberOfPages,
        rowsPerSize: action.payload.rowsPerSize,
        totalNumberOfPages: action.payload.totalNumberOfPages,
        totalWorkloadsCount: action.payload.totalWorkloadsCount,
        links: action.payload.links,
      }
    }
    case WorkloadActionTypes.SET_SELECTED_WORKLOAD: {
      return {
        ...state,
        selectedWorkload: action.payload,
      }
    }
    case WorkloadActionTypes.CLEAR_SELECTED_WORKLOAD: {
      return {
        ...state,
        selectedWorkload: {} as Workload,
      }
    }
    case WorkloadActionTypes.CLEAR_WORKLOAD: {
      return {
        ...state,
        workload: [],
        pageNumber: 1,
        rowsPerSize: 10,
        totalNumberOfPages: 0,
        totalWorkloadsCount: 0,
      }
    }
    case WorkloadActionTypes.SET_INTIAL_PAGE: {
      return {
        ...state,
        initialPage: true,
      }
    }
    case WorkloadActionTypes.CLEAR_INITIAL_PAGE: {
      return {
        ...state,
        initialPage: false,
      }
    }
    default: {
      return state
    }
  }
}
